<!-- @format -->

<chat-room-tag>
	<div class="container_contents">
		
    <div class="container_breadcrumb">
      <ul class="breadcrumb">
				<li class="breadcrumb-item"><a href="/chat" class="chat">チャットルーム</a></li>
				<li class="breadcrumb-item"><a href="/chat/index/{state.info.client_id}">{state.info.client_name}</a></li>
				<li class="breadcrumb-item"><h1>詳細</h1></li>
			</ul>
		</div><!--/.container_breadcrumb-->
		
		<div class="contents" style="height:{height}; overflow-y:scroll;" onscroll={(e)=>chatboxScroll(e)}>
			
			<section class="contents_area">
        <div class="area_chat">
          <div class="contents_block chat_matter" style="top:0px">
            <div class="container_matter-info">
              <ul class="information_list">
                <li class="information_list-item">
                  <span class="information_list-item-title" if={state.info.ad_id && !state.info.project_id}>公募案件ID:{state.info.ad_id}</span>
                  <span class="information_list-item-title" if={state.info.project_id}>プロジェクトID:{state.info.project_id}</span>
                </li>
              </ul><!--/.information_list-->
              <div class="matter-title">
                <a href="/ad/detail/{state.info.ad_id}" if={state.info.ad_id && !state.info.project_id}>{state.info.ad_title}</a>
                <a href="/project/detail/{state.info.project_id}" if={state.info.project_id}>{state.info.project_title}</a>
              </div>
            </div>
          </div>
          
          <div class="container_chat margin-spacing-3_top">
            <div class="wrap_chat wrap_chat-{item.who}" id="message-{item.id}" each={(item, i) in state.messages}>
              <div class="box_chat">
                <div class="user">
                  <div class="user-icon">
                    <img src="{item.icon}" alt="" if={item.who == 'writer'}>
                    <img src="/assets/img/icon_account.svg" alt="" if={item.who == 'client'}>
                  </div>
                  <div class="user-name" if={item.who == 'writer'}>{item.name}</div>
                  <div class="user-name" if={item.who == 'client'}>{state.info.client_name}</div>
                </div><!--/.user-->
                <div class="box_chat-message">
                  <template each={ogp in item.ogps}>
                    <ul class="attachment_list">
                      <li class="attachment_list-item" each={ogp in item.ogps} style="cursor:pointer" onclick={e=>openLink(ogp.url)}>
                        <a href="{ogp.url}" target="_blank"><img style="max-width:200px" src="{ogp.image}"></a>
                        <a href="{ogp.url}" target="_blank">{ogp.title}</a>
                        <a href="{ogp.url}" target="_blank">{ogp.host}</a>
                        <p>{ogp.description}</p>
                      </li>
                    </ul>
                  </template>

                  <ul class="file_list" if={item.type.startsWith("image/")}>
                    <li class="file_list-item">
                      <a target="_blank" onclick={(e)=>fileLink(e, item)}>
                        <img style="width:100%" src="/chat/room/api/v1/{RoomID}/image?uuid={item.uuid}">
                        <br />
                        {item.filename}
                      </a>
                    </li> 
                  </ul>
                  <ul class="file_list" if={item.type != "announce" && item.type != "message" && !item.type.startsWith("image/")}>
                    <li class="file_list-item"><a onclick={(e)=>fileLink(e, item)} target="_blank">{item.filename}</a></li>
                  </ul>
                  
                  <ul class="attachment_list" if={item.type=='announce'}>
                    <li class="attachment_list-item">
                      <span class="matter-id">{item.announce.label}</span>
                      <a href="{item.announce.link}">{item.announce.title}</a>
                    </li>
                  </ul>

                  <p class="text" style="white-space:pre-wrap">{item.message}</p>
                </div>
                <p if={item.who=="client"} class="message_date margin-spacing-1_top">{item.time}[{item.id}]</p>
                <p if={item.who=="writer"} class="message_date align_r margin-spacing-1_top">{item.time}[{item.id}]</p>
              </div><!--/.box_qa-->
            </div><!--/.wrap_qa-->
          </div>

          <div class="container_chat-input" if={!state.info.freezed_at}>
            <h2 class="heading-04 margin-spacing-2_bottom">メッセージ</h2>
            <textarea id="text" class="textarea_input margin-spacing-1_bottom" placeholder="ここにメッセージを記入してください" value={state.text} onkeydown={(e)=>keydown(e)}></textarea>
            <div class="box_flex01">
              <div class="wrap_button">
                <input type="file" id="file" style="display:none" onchange={(e)=>fileEvent(e)}>
                <div class="button button-tertiary-micro button-file margin-spacing-1_right" onclick={(e)=>selectfile(e)}></div>
              </div><!--/.wrap_button-->
              <div class="button button-secondary button-send" onclick={(e)=>sendMessage(e)}>送信する</div>
            </div>
          </div><!--/.container_chat-input-->
        </div><!--/.area_chat-->
			</section><!--/.contents_area-->
      <div id="bottom">&nbsp;</div>
		</div><!--/.contents-->
	</div><!--/.container_contents-->


<script>
  import di from "dependency-injection";
  import EdilentWorkerChatApi from "@model/chat-api";

  export default {
    ChatRoomApi: false,
    RoomID: false,
    height: "auto",
    state: {
      info: {},
      hostname: false,
      text: '',
      isBeforeLoading: false,
      isAfterLoading: true,
      messages: [],
    },
    openLink(url) {
      window.open(url);
    },
    goList(client_id) {
      di.router.push(`/chat/index/${client_id}`);
    },
    fileLink(e, item) {
      this.ChatRoomApi.request('download', {uuid: item.uuid, filename: item.filename})
        .then(data => {
          const downLoadLink = document.createElement("a");
          downLoadLink.href = data;
          downLoadLink.click();
        });
    },
    messageLength(){
      return this.state.messages.length;
    },
    getFirstMessage() {
      if (this.messageLength() === 0) return false;
      return this.state.messages[0];
    },
    getLastMessage() {
      if (this.messageLength() === 0) return false;
      return this.state.messages[this.messageLength() - 1];
    },
    searchMessage(id){
      for (let i in this.state.messages) {
        if (id === this.state.messages[i].id) return this.state.messages[i];
      }
      return false;
    },
    mergeMessage(items) {
      for (let i in items) {
        let id = items[i].id;
        if (this.searchMessage(id)) continue;

        let item = JSON.parse(items[i].data);
        item.time = items[i].created_at;
        item.id = id;
        if (item.bizid === __INITIAL_PROPS__.bizid) {
          item.who = 'writer';
        } else {
          item.who = 'client';
        }
        this.state.messages.push(item);
      }

      //ID順に並べておく
      this.state.messages.sort((a,b)=>{
        return (a.id - b.id);
      });
    },
    keydown(e){
      if (e.keyCode === 13 && e.ctrlKey) { // Enterが押された
        if ($('textarea#text').val().replace(/\s/g, "").length > 0) {
          e.preventDefault();
          this.sendMessage();
        }
      }
    },
    chatboxScroll(e) {
			if(e.target.scrollTop === 0) {
         if (this.getFirstMessage()) {
           this.update({isBeforeLoading: true});
           this.ChatRoomApi.request('before', {before: this.getFirstMessage().id})
             .then(data => this.onFetchBeforeSuccess(data));
         }
       }
			//{passive: true}

    },
    onFetchSuccess(data){
      this.mergeMessage(data.items);
      this.update({isAfterLoading: false});
    },
    viewLatest(behavior="auto"){
      setTimeout(()=>{
        document.querySelector('#bottom').scrollIntoView({behavior: behavior, block: "end", inline: "nearest"});
      }, 300);
    },
    onFetchBeforeSuccess(data) {
      if (data.items.length === 0) return;
      let firstMsg = this.getFirstMessage();
      this.mergeMessage(data.items);
      this.update({isBeforeLoading: false});
      setTimeout(()=>{
        document.querySelector(`#message-${firstMsg.id}`).scrollIntoView({behavior: "auto", block: "start", inline: "nearest"});
      }, 300);
    },
    onNewMessage(data){
      if (location.pathname !== `/chat/room/${data.room_id}`) return;
      this.update({isAfterLoading: true});
      this.ChatRoomApi.request('fetch', {after: data.messageId})
        .then(data => this.onFetchSuccess(data))
        .then(()=> this.viewLatest('smooth'));
    },
    onInfoSuccess(data){
      this.update({info: data});
    },
    onBeforeMount(props, state){
      this.state.messages = [];
      this.RoomID = props.routeParams[0] || false;
      if (!this.RoomID) {
        di.router.push('/chat');
        return;
      }
      this.ChatRoomApi = new EdilentWorkerChatApi(this.RoomID);

      di.SyncBox.registerHooks('chatNewMessageHandler', 'socket:newMessage', (data) => this.onNewMessage(data));

      this.state.host = location.protocol +'//'+ location.hostname ;

      this.ChatRoomApi.request('info')
        .then(data => this.onInfoSuccess(data))

      this.ChatRoomApi.request('fetch')
        .then(data => this.onFetchSuccess(data))
        .then(()=> this.viewLatest());
    },
    fileEvent(e) {
      const fd = new FormData();
      fd.append('file', e.target.files[0]);
      this.ChatRoomApi.request('upload', fd);
    },
    selectfile(e){
      this.$("input[type=file]").click();
    },
    sendMessage(e){
      let message = this.$('#text').value.trim();
      if (!message) {
        return;
      }
      this.$('#text').value = '';
      this.update({isAfterLoading: true});
      this.ChatRoomApi.request('sendmessage', {message:message});
    },
    onMounted(){
      this.height = document.querySelector("#root > menu-sideber nav.gnav").clientHeight + 24 +'px';
      this.update();
    }
  }
</script>
</chat-room-tag>
